import { render, staticRenderFns } from "./targetEdition.vue?vue&type=template&id=72749869&scoped=true"
import script from "./targetEdition.vue?vue&type=script&lang=js"
export * from "./targetEdition.vue?vue&type=script&lang=js"
import style0 from "./targetEdition.vue?vue&type=style&index=0&id=72749869&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72749869",
  null
  
)

export default component.exports